import { GridConfig } from "../../../../../../../src/types/Interface";


export default function genPivotPoint(gridConfig: GridConfig) {
  const offset = 3;
  const u = Math.abs(gridConfig.width / gridConfig.cellSize - offset * 2);
  const v = Math.abs(gridConfig.height / gridConfig.cellSize - offset * 2);

  return {
    x: Math.floor(Math.random() * u) + offset,
    y: Math.floor(Math.random() * v) + offset
  }
}